import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'containerDetails' })
export class ContainerDetails implements PipeTransform 
{
  transform(value: string): string 
  {
    var status = value ? value.charAt(0).toUpperCase() + value.slice(1) : '';
    
    //contract types
    if (value == '3months') 
    {
      status = 'Contracted within 3 months'
    }
    else if (value == '6months') 
    {
      status = 'Contracted within 6 months'
    }
    else if (value == '1month') 
    {
      status = 'Contracted within 1 month'
    }
    else if (value == 'all') 
    {
      status = 'All Long Contracts'
    }
   
    //price types
    else if (value == 'high') 
    {
      status = 'High'
    }
    else if (value == 'midhigh') 
    {
      status = 'Mid-High'
    }
    else if (value == 'mean') 
    {
      status = 'Average'
    }
    else if (value == 'midlow') 
    {
      status = 'Mid-Low'
    }
    else if (value == 'low') 
    {
      status = 'Low'
    }
    else if (value == 'median') 
    {
      status = 'Median'
    }

    // weight_bracket
    else if (value == 'less_than_45kg') 
    {
        status = '<45 Kg'
    }
    else if (value == 'greater_than_45kg') 
    {
        status = '45+ Kg'
    }
    else if (value == 'greater_than_200kg') 
    {
        status = '200+ Kg'
    }
    else if (value == 'greater_than_500kg') 
    {
        status = '500+ Kg'
    }
    else if (value == 'greater_than_1000kg') 
    {
        status = '1000+ Kg'
    }

    //service_level tier
    else if (value == 'upper_tier') 
    {
        status = 'Upper Tier'
    }
    else if (value == 'mid_tier') 
    {
        status = 'Mid Tier'
    }
    else if (value == 'lower_tier') 
    {
        status = 'Lower Tier'
    }
    else if (value == 'lower_and_mid_tier') 
    {
        status = 'Lower and Mid Tier'
    }
    else if (value == 'passive') 
    {
        status = 'Passive'
    }

    //thc types
    else if (value == 'meth') 
    {
        status = 'Default THC'
    }
    else if (value == 'othc') 
    {
        status = 'Origin THC'
    }
    else if (value == 'dthc') 
    {
        status = 'Destination THC'
    }
    else if (value == 'both') 
    {
        status = 'Both THC'
    }
    else if (value == 'none') 
    {
        status = 'None THC'
    }
    //container types
    else if (value == '20DC') 
    {
        status = "20' Standard Dry"
    }
    else if (value == '40DC') 
    {
        status = "40' Standard Dry"
    }
    else if (value == '20RE') 
    {
        status = "20' Reefer"
    }
    else if (value == '40RH') 
    {
        status = "40' Reefer HC"
    }
    else if (value == '20TK') 
    {
        status = "20' Tank"
    }
    else if (value == '40HC') 
    {
        status = "40' High Cube"
    }

    return status;
  }

}